import { makeStyles } from "@material-ui/core/styles"

export default makeStyles(theme => ({
    publishedText: {
        marginTop: 50,
        marginBottom: 15
    },
    itemThumbnail: {
        width: "100%",
        minHeight: 500
    },
    container: {
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3)
    },
    pageTitle: {
        display: "flex",
        gap: 25,
        marginTop: 50
    },
    skeletonText: {
        marginTop: 50,
        marginBottom: 15,
        width: "33%"
    },
    skeletonRect: {
        height: 500
    }
}))
